/**
 * Do not edit directly, this file was auto-generated
 */

export const ColorPinkLightest = "#FCE6FF";
export const ColorPinkLight = "#F3B3FE";
export const ColorPinkBase = "#EB80FD";
export const ColorPinkDark = "#8E4D97";
export const ColorPinkDarkest = "#47264C";
export const ColorGreenLightest = "#D2F2E3";
export const ColorGreenLight = "#77D9AB";
export const ColorGreenBase = "#1DBF73";
export const ColorGreenDark = "#137345";
export const ColorGreenDarkest = "#0A3922";
export const ColorRedLightest = "#FFE1D8";
export const ColorRedLight = "#FEA689";
export const ColorRedBase = "#FF643B";
export const ColorRedDark = "#984023";
export const ColorRedDarkest = "#4C2011";
export const ColorPurpleLightest = "#EEE2FF";
export const ColorPurpleLight = "#D7C0FF";
export const ColorPurpleBase = "#C09DFF";
export const ColorPurpleDark = "#834FCA";
export const ColorPurpleDarkest = "#460095";
export const ColorBlueLightest = "#CCF0F8";
export const ColorBlueLight = "#66D2EA";
export const ColorBlueBase = "#00B4DC";
export const ColorBlueDark = "#006C85";
export const ColorBlueDarkest = "#003642";
export const ColorYellowLightest = "#F7F2D8";
export const ColorYellowLight = "#E7D88A";
export const ColorYellowBase = "#D8C833";
export const ColorYellowDark = "#817224";
export const ColorYellowDarkest = "#403911";
export const ColorGrayLightest = "#F6F6F7";
export const ColorGrayLight = "#D9DADB";
export const ColorGrayBase = "#B1B4B5";
export const ColorGrayDark = "#5A5F62";
export const ColorGrayDarkest = "#383C3E";
export const ColorNeutralCream = "#F7F2D8";
export const ColorNeutralBlack = "#000000";
export const ColorNeutralWhite = "#ffffff";
export const ColorTransparency00 = "#ffffff";
export const ColorBrandDefault = "#C09DFF";
export const ColorBrandAccent = "#1DBF73";
export const Space25 = "2px";
export const Space50 = "4px";
export const Space100 = "8px";
export const Space150 = "12px";
export const Space200 = "16px";
export const Space250 = "20px";
export const Space300 = "24px";
export const Space400 = "32px";
export const Space500 = "40px";
export const Space600 = "48px";
export const Space700 = "56px";
export const Space800 = "64px";
export const Space900 = "72px";
export const Space1000 = "80px";
export const Space1100 = "88px";
export const Space1200 = "96px";
export const SpaceNone = "0px";
export const SpaceBase = "8px";
export const BorderWidth100 = "1px";
export const BorderWidth200 = "2px";
export const BorderWidthNone = "0px";
export const BorderRadius100 = "3px";
export const BorderRadius200 = "8px";
export const BorderRadius300 = "16px";
export const BorderRadius400 = "32px";
export const BorderRadiusNone = "0px";
export const BorderRadiusPill = "9999px";
export const BorderRadiusCircle = "1000px";
export const FontFamilyDMSans = "DM Sans";
export const FontWeight100 = 400;
export const FontWeight200 = 500;
export const LineHeight25 = "16px";
export const LineHeight50 = "24px";
export const LineHeight100 = "32px";
export const LineHeight200 = "40px";
export const LineHeight300 = "48px";
export const LineHeight400 = "56px";
export const LineHeight500 = "64px";
export const LineHeight600 = "72px";
export const LineHeightTight = "1.1";
export const LineHeightStandard = "1.25";
export const LineHeightLoose = "1.5";
export const FontSize10 = "12px";
export const FontSize25 = "14px";
export const FontSize50 = "15px";
export const FontSize100 = "16px";
export const FontSize200 = "18px";
export const FontSize300 = "20px";
export const FontSize400 = "22px";
export const FontSize500 = "24px";
export const FontSize600 = "28px";
export const FontSize700 = "32px";
export const FontSize800 = "36px";
export const FontSize900 = "40px";
export const FontSize1000 = "48px";
export const FontSizeBase = "16px";
export const TextDecorationNone = "none";
export const TextDecorationUnderline = "underline";
export const Size0 = "0rem";
export const Size8 = "8rem";
export const Size12 = "12rem";
export const Size16 = "16rem";
export const Size20 = "20rem";
export const Size24 = "24rem";
export const Size32 = "32rem";
export const Size40 = "40rem";
export const Size48 = "48rem";
export const Size56 = "56rem";
export const Size64 = "64rem";
export const Size72 = "72rem";
export const Size80 = "80rem";
export const Size88 = "88rem";
export const Size96 = "96rem";
export const Size104 = "104rem";
export const ShadowLow = "0px 2px 2px 0px #0000001a,0px 0px 4px 0px #0000001a";
export const ShadowMedium = "0px 2px 2px 0px #0000001a,0px 4px 4px 0px #00000026";
export const ShadowHigh = "0px 0px 4px 0px #00000014,0px 8px 15px 2px #00000014";
